import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentLocalizedDatePipe } from './moment-localized-date.pipe';
import { MomentLocalizedDateService } from './moment-localized-date.service';

@NgModule({
  imports: [
    CommonModule,
    MomentLocalizedDatePipe, // ✅ import standalone pipe
  ],
  exports: [
    MomentLocalizedDatePipe, // ✅ re-export for consumers
  ],
  providers: [
    MomentLocalizedDateService,
  ],
})
export class MomentLocalizedDateModule { }
